// Minimal country list (extend as needed). Flag is unicode regional-indicator pair.
export const COUNTRIES = [
  { iso: "ZA", name: "South Africa",   dial: "+27",  flag: "\uD83C\uDDFF\uD83C\uDDE6" },
  { iso: "US", name: "United States",  dial: "+1",   flag: "\uD83C\uDDFA\uD83C\uDDF8" },
  { iso: "GB", name: "United Kingdom", dial: "+44",  flag: "\uD83C\uDDEC\uD83C\uDDE7" },
  { iso: "AU", name: "Australia",      dial: "+61",  flag: "\uD83C\uDDE6\uD83C\uDDFA" },
  { iso: "NZ", name: "New Zealand",    dial: "+64",  flag: "\uD83C\uDDF3\uD83C\uDDFF" },
  { iso: "NG", name: "Nigeria",        dial: "+234", flag: "\uD83C\uDDF3\uD83C\uDDEC" },
  { iso: "KE", name: "Kenya",          dial: "+254", flag: "\uD83C\uDDF0\uD83C\uDDEA" },
  { iso: "ZW", name: "Zimbabwe",       dial: "+263", flag: "\uD83C\uDDFF\uD83C\uDDFC" },
  { iso: "ZM", name: "Zambia",         dial: "+260", flag: "\uD83C\uDDFF\uD83C\uDDF2" },
  { iso: "BW", name: "Botswana",       dial: "+267", flag: "\uD83C\uDDE7\uD83C\uDDFC" },
  { iso: "NA", name: "Namibia",        dial: "+264", flag: "\uD83C\uDDF3\uD83C\uDDE6" },
  { iso: "MZ", name: "Mozambique",     dial: "+258", flag: "\uD83C\uDDF2\uD83C\uDDFF" },
  { iso: "AE", name: "UAE",            dial: "+971", flag: "\uD83C\uDDE6\uD83C\uDDEA" },
  { iso: "IN", name: "India",          dial: "+91",  flag: "\uD83C\uDDEE\uD83C\uDDF3" },
  { iso: "SG", name: "Singapore",      dial: "+65",  flag: "\uD83C\uDDF8\uD83C\uDDEC" },
  { iso: "DE", name: "Germany",        dial: "+49",  flag: "\uD83C\uDDE9\uD83C\uDDEA" },
  { iso: "FR", name: "France",         dial: "+33",  flag: "\uD83C\uDDEB\uD83C\uDDF7" },
  { iso: "CA", name: "Canada",         dial: "+1",   flag: "\uD83C\uDDE8\uD83C\uDDE6" },
];

export const DEFAULT_COUNTRY = "ZA";

export function validatePassword(pw) {
  if (pw.length < 8) return "At least 8 characters";
  if (!/[a-z]/.test(pw)) return "One lowercase letter";
  if (!/[A-Z]/.test(pw)) return "One uppercase letter";
  if (!/\d/.test(pw)) return "One number";
  if (!/[^A-Za-z0-9]/.test(pw)) return "One special character (!@#$…)";
  return null;
}
